module.exports = __webpack_public_path__ + "img/process.fee20afa.jpg";